export default __webpack_public_path__ + "static/media/Corner-Piece-P14.d97f8a4b.dwg";